import React from 'react';

const ShieldCheckIcon = ({ size = 16, fill = '#0F48B8' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ShieldCheckIcon"
      aria-label="Shield Check Icon"
      role="img"
    >
      <g clipPath="url(#clip0_3908_10006)">
        <path
          d="M8.42129 0.0911233C8.28932 0.0314218 8.14792 0 8.00024 0C7.85256 0 7.71116 0.0314218 7.57919 0.0911233L1.66245 2.60173C0.971173 2.89395 0.455856 3.57581 0.458999 4.39906C0.47471 7.5161 1.75672 13.2192 7.1707 15.8115C7.69545 16.0628 8.30503 16.0628 8.82978 15.8115C14.2438 13.2192 15.5258 7.5161 15.5415 4.39906C15.5446 3.57581 15.0293 2.89395 14.338 2.60173L8.42129 0.0911233ZM11.5509 6.56716L7.52891 10.5892C7.23355 10.8845 6.75593 10.8845 6.46371 10.5892L4.45271 8.57816C4.15735 8.2828 4.15735 7.80518 4.45271 7.51296C4.74808 7.22074 5.22569 7.2176 5.51791 7.51296L6.99474 8.98979L10.4826 5.49882C10.7779 5.20346 11.2555 5.20346 11.5478 5.49882C11.84 5.79419 11.8431 6.2718 11.5478 6.56402L11.5509 6.56716Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3908_10006">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShieldCheckIcon;

